import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [click, setClick] = useState(false);

  const handleEmail = () => {
    setClick(true);
    navigator.clipboard.writeText('nicoalanis14@gmail.com');

    setTimeout(() => {
      setClick(false);
    }, 2000);
  };

  return (
    <div className="contact-container" id="contact">
      <div className="contact-main">
        <div className="contact-left">
          <hr width="300"></hr>
          <h1>Contact.</h1>
        </div>
        <div className="contact-right">
          <p className="responsiveP">
            Say hi! <br />
            Interested in my projects? If you want to know more about them, send
            me an{' '}
            <span className="email" onClick={handleEmail}>
              email
            </span>{' '}
            or contact me trough my social media.
          </p>
          <p>
            I'm officially looking for a job! I'm located in Argentina so I'm
            mostly looking remote, althought I can relocate if needed.
            <br></br> DMs are open! Thanks!
          </p>
          <div className={`msg-copy-email ${click ? 'copy' : ''}`}>
            <p>¡Copied!</p>
          </div>
          <ul className="nav">
            <li>
              <a
                target="_blank"
                href="https://github.com/nicoalanis14"
                rel="noreferrer"
                alt="GitHub"
              >
                Git
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.linkedin.com/in/nicolas-alanis-3314401bb/"
                rel="noreferrer"
                alt="Linkedin"
              >
                Lk
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://twitter.com/nicoalanis14  "
                rel="noreferrer"
                alt="Twitter"
              >
                Tw
              </a>
            </li>
            <li>
              <a
                target="_blank"
                href="https://www.instagram.com/nico_alanis14/"
                rel="noreferrer"
                alt="Instagram"
              >
                In
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Contact;
